import { ApplicationRef, ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { OtpModalComponent } from './otp-modal/otp-modal.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class OtpModalService {

  private containerRef!: ViewContainerRef;
  private componentRef: ComponentRef<OtpModalComponent> | null = null;
  private otpSubject = new Subject<string>();

  constructor(private appRef: ApplicationRef, private http: HttpClient) { }


  setContainer(container: ViewContainerRef) {
    this.containerRef = container;
  }

  openOtp(apiData: any) {
    console.log('opent otp service method called');
    console.log('otp service container 1 ' , this.containerRef);

    if (!this.containerRef) return;
    console.log('otp service container 2 ' , this.containerRef);

    this.closeOtp(); // Ensure previous instance is destroyed before creating a new one

    this.componentRef = this.containerRef.createComponent(OtpModalComponent);
    console.log('otp service componentref ' , this.componentRef);
    if (this.componentRef) {
      this.componentRef.instance.latestCashedSecuredApiData = apiData; // Pass data to the component
      this.appRef.tick(); // Force UI update
    }
  }

  closeOtp() {
    if (this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = null;
      this.appRef.tick(); // Ensure UI updates after removal
    }
  }

  sendOtpToUserViaMail() {
    return this.http.post(environment.url + `v2/admin/schools/${localStorage.getItem('schoolId')}/send-otp`, {})
  }

  retryWithOtp(method: string, url: string, body?: any) {
    switch (method.toUpperCase()) {
      case 'GET':
        return this.http.get(url);
      case 'POST':
        return this.http.post(url, body);
      case 'PUT':
        return this.http.put(url, body);
      case 'DELETE':
        if (body) {
          // DELETE with body (rare but sometimes needed)
          return this.http.request('DELETE', url, { body });
        } else {
          // Standard DELETE without body
          return this.http.delete(url);
        } 
        default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }
}
